import { Marked, Renderer } from "marked";
import type { ContentImage } from "@/lib/content-types";

const escapeAttribute = (value: string) =>
	value
		.replace(/&/g, "&amp;")
		.replace(/"/g, "&quot;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;");
const SIZES = "(min-width: 944px) 896px, calc(100vw - 48px)";
function picture(image: ContentImage, attributes: string) {
	const sources = image.sources
		.map(
			(source) =>
				`<source type="${source.type}" srcset="${escapeAttribute(source.srcSet)}" sizes="${SIZES}">`,
		)
		.join("");
	return `<picture>${sources}<img src="${escapeAttribute(image.src)}" width="${image.width}" height="${image.height}" sizes="${SIZES}"${attributes} loading="lazy" decoding="async"></picture>`;
}
export function renderContentMarkdown(
	body: string,
	media: Record<string, ContentImage> = {},
) {
	return new Marked({
		async: false,
		renderer: {
			table(token) {
				return `<div class="max-w-full overflow-x-auto" tabindex="0">${Renderer.prototype.table.call(this, token)}</div>`;
			},
			image(token) {
				const image = media[token.href];
				if (!image) return false;
				return picture(
					image,
					` alt="${escapeAttribute(token.text)}"${token.title ? ` title="${escapeAttribute(token.title)}"` : ""}`,
				);
			},
			html(token) {
				// Only rendered HTML tokens reach this hook; fenced and inline code stay intact.
				return token.text.replace(/<img\b[^>]*>/gi, (tag) => {
					const src = tag.match(/\bsrc\s*=\s*(["'])(.*?)\1/i)?.[2];
					const image = src ? media[src] : undefined;
					if (!image) return tag;
					const attributes = tag
						.replace(/^<img\b/i, "")
						.replace(/\/?\s*>$/, "")
						.replace(
							/\s+\b(?:src|width|height|sizes|srcset|loading|decoding)\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi,
							"",
						);
					return picture(image, attributes);
				});
			},
		},
	}).parse(body, { async: false });
}
